module.exports = __webpack_public_path__ + "static/play-store-4a3256fc73024a1691822481f3a548c5.svg";